import useModal from 'hooks/useModal';
import { ReactNode } from 'react';
import { DeleteRecurring, RecurringForm } from './RecurringComponents';
import { DeleteRecurringProps, RecurringFormProps } from './types';

type OpenProps = Omit<RecurringFormProps, 'flow' | 'onCancel'> & {
  onCancel?: () => void;
};

type DeleteProps = Omit<DeleteRecurringProps, 'onCancel'> & {
  onCancel?: () => void;
};

type ReturnType = [
  ReactNode,
  {
    create: (props: OpenProps) => void;
    edit: (props: OpenProps) => void;
    delete: (props: DeleteProps) => void;
    close: () => void;
  },
];

const useRecurringForm = (): ReturnType => {
  const [content, api] = useModal({
    name: 'recurring expense form',
    width: '2xl',
  });

  const _api: ReturnType[1] = {
    close: api.close,

    create: (props) => {
      api.open(() => (
        <RecurringForm
          flow="create/edit"
          {...props}
          onCancel={() => {
            api.close();
            props.onCancel?.();
          }}
        />
      ));
    },
    edit: (props) => {
      api.open(() => (
        <RecurringForm
          flow="delete/edit"
          {...props}
          onCancel={() => {
            api.close();
            props.onCancel?.();
          }}
        />
      ));
    },
    delete: (props) => {
      api.open(() => (
        <DeleteRecurring
          {...props}
          onCancel={() => {
            api.close();
            props.onCancel?.();
          }}
        />
      ));
    },
  };

  return [content, _api];
};

export default useRecurringForm;
